(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('topRightSchema',  topRightSchemaInject);

  /** @ngInject */
  function topRightSchemaInject() {
    var directive = {
      restrict: 'E',
      templateUrl: 'assets/schema/reverseOsmasisSubSystem-resized.svg',
      controller: TopRightSchemaController,
      controllerAs: 'vm',
      scope: {
        ro: '=',
        demi: '='
      }
    };

    return directive;

    /** @ngInject */
    function TopRightSchemaController($scope, schemaUtils) {
      var vm = this;

      $scope.$watchGroup(['ro.lps', 'ro.fwy', 'ro.motor', 'ro.motorError'], function (newValue) {
        vm.lps = newValue[0] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;
        vm.fwy = newValue[1] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;

        if (newValue[3]) {
          vm.motorRo = schemaUtils.COLORS.error;
        } else {
          vm.motorRo = newValue[2] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }
      });

      $scope.$watchGroup(['demi.highFloat', 'demi.lowFloat', 'demi.motorError', 'demi.motor'], function (newValue) {
        vm.highFloat = newValue[0] ? schemaUtils.COLORS.highFloatWorking : schemaUtils.COLORS.highFloatNotWorking;
        vm.lowFloat = newValue[1]  ? schemaUtils.COLORS.error : schemaUtils.COLORS.working;

        if (newValue[2]) {
          vm.motorDemi = schemaUtils.COLORS.error;
        } else {
          vm.motorDemi = newValue[3] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }
      });


    }
  }

})();
